import { ModelType } from '@/modules/core/app/constants/ModelType';
import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { DocumentExtraction } from '@/modules/ai/models/DocumentExtraction';

export class ExtractedTransaction extends BaseEntityModel {
  id?: number;
  documentExtractionId?: number;
  date?: string;
  amount?: number;
  description?: string;
  documentExtraction?: Relationship<DocumentExtraction> | null;

  constructor(model: Partial<ExtractedTransaction> = {}) {
    super(model);

    this.id = model.id;
    this.documentExtractionId = model.documentExtractionId;
    this.date = model.date;
    this.amount = model.amount;
    this.description = model.description;

    this.documentExtraction = DocumentExtraction.mapModelOrNull(model.documentExtraction);
  }

  getModelName(): ModelType {
    return ModelType.EXTRACTED_TRANSACTION;
  }

  get debit(): number | undefined {
    if (this.amount === undefined) {
      return undefined;
    }

    if (this.amount < 0) {
      return this.amount * -1;
    }

    return 0;
  }

  set debit(value?: number): void {
    if (value === undefined) {
      this.amount = undefined;
      return;
    }

    this.amount = value > 0 ? value * -1 : value;
  }

  get credit(): number | undefined {
    if (this.amount === undefined) {
      return undefined;
    }

    if (this.amount > 0) {
      return this.amount;
    }

    return 0;
  }

  set credit(value?: number): void {
    if (value === undefined) {
      this.amount = undefined;
      return;
    }

    this.amount = value < 0 ? value * -1 : value;
  }
}
